import { render, staticRenderFns } from "./transactions_table.vue?vue&type=template&id=1f2efd01&lang=pug&"
import script from "./transactions_table.vue?vue&type=script&lang=js&"
export * from "./transactions_table.vue?vue&type=script&lang=js&"
import style0 from "./transactions_table.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports